import { getVehicleByModelLineCode } from '../redux/selectors/models';
import { get, geti18n } from './index';

/**
 * Large and messy function to programatically create the url to the
 * images location in the CMS DAM. Dam path's are not always clear
 * and so the function needs to map certain names to others.
 * @param vehicle - a vehicle Object
 * @param brand - The full name of the brand
 * @returns {{bodyStyle: string, modelLine: *, name: *}}
 */
const getVehicleVariables = (vehicle, brand) => {
  const body = vehicle.bodyStyle.toLowerCase();
  let name = vehicle.modelLineFullName.toLowerCase().split('-')[0];
  const vehicleVariables = {
    bodyStyle: body,
    modelLine: name,
    name
  };
  if (brand === 'infiniti') {
    if (name === 'qx80') {
      vehicleVariables.bodyStyle = 'suv';
    } else if (body.includes('sedan')) {
      if (name === 'q70l') {
        vehicleVariables.bodyStyle = 'sedan';
        vehicleVariables.name = 'q70L';
      } else {
        vehicleVariables.bodyStyle = 'sedan';
      }
    } else if (body.includes('coupe')) {
      vehicleVariables.bodyStyle = 'coupe';
      vehicleVariables.name = `${name}-coupe`;
    } else if (body.includes('crossover')) {
      vehicleVariables.bodyStyle = 'crossover';
    }
  } else {
    name = vehicle.modelLineFullName.toLowerCase().replace(new RegExp('(™|®|©|&trade;|&reg;|&copy;|&#8482;|&#174;|&#169;)', 'g'), '');
    vehicleVariables.name = name;
    vehicleVariables.modelLine = name;
    if ((body.includes('car') || body.includes('autos')) && !body.includes('sports') && !body.includes('electric')) {
      vehicleVariables.bodyStyle = 'cars';
    } else if (body.includes('electric') || body.includes('ELÉCTRICO'.toLowerCase())) {
      vehicleVariables.bodyStyle = 'electric-cars';
    } else if (body.includes('sports') || body.includes('deportivos')) {
      vehicleVariables.bodyStyle = 'sportscars';
      if (name.includes('coupe')) {
        vehicleVariables.modelLine = 'z-coupe';
      } else if (name.includes('roadster')) {
        vehicleVariables.modelLine = 'z-roadster';
      }
    } else if (body.includes('crossover')) {
      if (name.toLowerCase() === 'armada' || name.toLowerCase() === 'pathfinder') {
        vehicleVariables.bodyStyle = 'suvs';
      } else {
        vehicleVariables.bodyStyle = 'crossovers';
      }
    } else if (body.includes('minivan')) {
      vehicleVariables.bodyStyle = 'minivans'
    } else if (body.includes('truck') || body.includes('camionetas')) {
      vehicleVariables.bodyStyle = 'trucks';
    } else if (body.includes('comerciales')) {
      vehicleVariables.bodyStyle = 'commercial';
    }
  }
  return vehicleVariables;
};

/**
 * Function to return the url for a specific vehicles image from the CMS DAM
 * @param state - the state from the store
 * @param modelLineCode - the Code of the
 * @param size
 * @returns {*}
 */
export const createImageURL = (state, modelLineCode, size = 'medium') => {
  const vehicle = getVehicleByModelLineCode(state, modelLineCode);
  if (!vehicle) {
    return '';
  }
  const environment = get(state, 'environment');
  const brand = environment.BRAND_NAME;
  // eslint-disable-next-line
  //console.log(environment);
  'thi® s tes™ ®t awer®'.replace(new RegExp('[®™]', 'g'), '', this)
  const options = getVehicleVariables(vehicle, brand);
  return `${state.config.brandPath}/dam/${brand}/vehicles/${options.bodyStyle}/${options.modelLine}/${vehicle.year}/sav/${vehicle.year}-${brand}-${options.name}-${size}.jpg`;
};

export const createImageAlt = (state, modelLineCode) => {
  const vehicle = getVehicleByModelLineCode(state, modelLineCode);
  if (!vehicle) {
    return '';
  }
  return `${vehicle.year} ${geti18n('brandTitle')} ${vehicle.modelLineFullName}`;
};



/** WEBPACK FOOTER **
 ** ./src/utils/vehicleImageURL.js
 **/